var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack3Solid02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.51,10.38v1.4H5.21a3.59,3.59,0,0,1,.52-1.5,9.72,9.72,0,0,1,1.7-1.89A11.24,11.24,0,0,0,8.68,7.1,1.64,1.64,0,0,0,9,6.18a1.06,1.06,0,0,0-.27-.78A1,1,0,0,0,8,5.13a1,1,0,0,0-.75.28,1.41,1.41,0,0,0-.32,1L5.39,6.21a2.45,2.45,0,0,1,.85-1.79A2.83,2.83,0,0,1,8,3.88a2.6,2.6,0,0,1,1.83.62,2.09,2.09,0,0,1,.67,1.57,2.67,2.67,0,0,1-.2,1,3.77,3.77,0,0,1-.6,1,9.73,9.73,0,0,1-1,1c-.47.44-.78.73-.9.87a2.26,2.26,0,0,0-.31.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack3Solid02);
export default __webpack_public_path__ + "static/media/Symbolpack_3_solid_02.5cbd56ebef49218f4a14ddb89f73f09e.svg";
export { ForwardRef as ReactComponent };